import PropTypes from 'prop-types';
import { Dropdown } from 'antd';

// Import icons
import { ReactComponent as IconRec } from 'assets/icons/ic_rec.svg';

// Import components
import { RecordingsMenu } from 'components/elements';
import SimpleLoader from '../SimpleLoader';

// Import hooks
import { useProgramRecordings } from './useProgramRecordings';
import { useUserAgent } from 'components/utilities';

// Import styles
import { ButtonRecord } from './styles';

const ProgramRecordings = ({ programId, isDetails, isNpvrActive, iconDimensions = '25px' }) => {
	const { scheduleNpvrRecordings, isLoading, isRecorded } = useProgramRecordings(programId);
	const { isMobile } = useUserAgent();
	const triggers = isMobile ? ['click'] : ['hover'];

	if (isLoading) return <SimpleLoader size={25} />;

	return (
		<>
			{isRecorded ? (
				<ButtonRecord padding="0" isProgramRecorded={isRecorded} disabled={isRecorded} isDetails={isDetails}>
					<IconRec width={iconDimensions} height={iconDimensions} />
				</ButtonRecord>
			) : (
				<Dropdown trigger={triggers} overlay={() => <RecordingsMenu scheduleNpvrRecording={scheduleNpvrRecordings} isNpvrActive={isNpvrActive} />}>
					<ButtonRecord padding="0" isProgramRecorded={isRecorded} isDetails={isDetails}>
						<IconRec width={iconDimensions} height={iconDimensions} />
					</ButtonRecord>
				</Dropdown>
			)}
		</>
	);
};

ProgramRecordings.defaultProps = {
	isDetails: false
};

ProgramRecordings.propTypes = {
	programId: PropTypes.string.isRequired,
	isDetails: PropTypes.bool.isRequired,
	isNpvrActive: PropTypes.bool,
	iconDimensions: PropTypes.string
};

export default ProgramRecordings;
